
export const withdrawalConfig = [
  {
    gateway: "WIRE_TRANSFER",
    name: "Wire Transfer",
    image: "/img/payment-method/wire-transfer.png",
    allowed: {
      wallet: true,
      mt5: true,
    },
    config: {},
  },
  {
    gateway: "CRYPTO",
    name: "Crypto",
    image: "/img/payment-method/crypto.png",
    allowed: {
      wallet: true,
      mt5: true,
    },
    config: {
      methods: [
        {
          network: "TRC20",
          coins: ["USDT"]
        },
        {
          network: "BEP20",
          coins: ["USDT"]
        }
      ]
    },
  },
  // {
  //   gateway: "CASH",
  //   name: "Cash",
  //   image: "/img/payment-method/cash.jpeg",
  //   allowed: {
  //     wallet: true,
  //     mt5: true,
  //   },
  //   config: {},
  // },
  // {
  //   gateway: "SADAAD_PAY",
  //   name: "Sadaad Pay",
  //   image: "/img/payment-method/6.png",
  //   allowed: {
  //     wallet: true,
  //     mt5: true,
  //   },
  //   receipt: false,
  //   isSandbox: false,
  // },
  {
    gateway: "HESABE",
    name: "Hesabe",
    image: "/img/payment-method/hesabe.png",
    allowed: {
      wallet: true,
      mt5: true,
    },
    receipt: false,
    isSandbox: false,
  },

];
